import { createAsyncThunk } from '@reduxjs/toolkit'
import { fetchPartnerBasicInfo } from 'legacy/lut/services/partner360/basicInfo/fetchPartnerBasicInfo'
import { IJBPBasicInfoCrudParams } from 'legacy/lut/services/partner360/basicInfo/models'

import { YEAR_WHEN_GP_APPEARS } from '../../../globalPartner/constants'
import { REQUEST_BASIC_INFO_DATA } from '../constants'
import { isBasicInfoCreated, isBasicInfoDefault } from '../helpers/typeGuards'
import { IBasicInfoState } from '../models/basicInfoState'

type TRequestBasicInfoDataResult = Pick<IBasicInfoState, 'createdData' | 'defaultData'>

export const requestBasicInfoData = createAsyncThunk<
  TRequestBasicInfoDataResult | undefined,
  IJBPBasicInfoCrudParams
>(
  REQUEST_BASIC_INFO_DATA,
  async (params) => {
    const basicInfos = await fetchPartnerBasicInfo(params)

    const createdBasicInfo = basicInfos.find(isBasicInfoCreated)
    const defaultBasicInfo = basicInfos.find(isBasicInfoDefault)

    if (!defaultBasicInfo) {
      return
    }

    return {
      createdData: createdBasicInfo || {
        ...defaultBasicInfo,
        entryId: undefined,
        programType: params.programType,
        partnerId: params.partnerId,
        fYear: params.fYear,
      },
      defaultData: defaultBasicInfo,
    }
  },
  {
    condition: async ({ partnerId, programType, fYear }) => {
      if (!fYear || !programType || !partnerId) {
        return false
      }

      if (partnerId.startsWith('GP') && fYear < YEAR_WHEN_GP_APPEARS) {
        return false
      }

      return
    },
  }
)
